import isNil from 'lodash/isNil';
import { capitalizeFirstLetter, formatDuration } from 'UI/utils';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    type: capitalizeFirstLetter(item?.type ?? ''),
    duration: !isNil(item?.secDuration) ? formatDuration(item?.secDuration) : null,
    userId: item?.giverFortpacId,
    employeeFile: {
      saveInEmployeeFile: item?.saveInEmployeeFile,
      successfullySavedToEmployeeFile: item?.successfullySavedToEmployeeFile,
      lastSavedToEmployeeFileResult: item?.lastSavedToEmployeeFileResult
    }
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
